import type { UiClick, UiContentView } from '@/metrics/uiMetrics'
import { uiEventContext } from '@/metrics/uiEventContext'

// The app shell's UI clicks: each is captured as it happens, on the page it happened on, and
// reported once the metrics chunk (kept off the boot chunk) has loaded.

const loadUiMetrics = () => import('@/metrics/uiMetrics')

// Metrics are observational: a chunk that fails to load drops the report.
const dropReport = () => {}

export function reportShellClick(click: UiClick): void {
    const context = uiEventContext()
    loadUiMetrics()
        .then(({ reportClick }) => reportClick(click, context))
        .catch(dropReport)
}

/** A shell link was clicked; one to the page already shown makes GH push a fresh copy of it. */
export function reportShellNavigation(click: UiClick, reopened: boolean): void {
    const context = uiEventContext()
    loadUiMetrics()
        .then(({ reportClick, reportRoutedPageAgain }) => {
            reportClick(click, context)
            if (reopened) reportRoutedPageAgain(context.timestamp)
        })
        .catch(dropReport)
}

export function reportShellContentView(view: UiContentView): void {
    const context = uiEventContext()
    loadUiMetrics()
        .then(({ reportContentView }) => reportContentView(view, context))
        .catch(dropReport)
}
